import { ProductVariant } from '@shopify/hydrogen-react/storefront-api-types';
import React from 'react';
import Toggle, { ToggleItem } from '../../components/ui/Toggle';

interface Props {
  variant: ProductVariant;
}

const ProductInfo: React.FC<Props> = ({ variant }) => {
  const items = variant.metafields.reduce((a, item) => {
    if (!item?.key) {
      return a;
    }

    if (item?.key === 'color') {
      return a;
    }
    let title = item?.key;
    if (item?.key === 'shipping_and_returns') {
      title = 'Shipping and returns';
    }
    a.push({
      title: title || '',
      children: `<div>${item?.value}</div>`,
    });
    return a;
  }, [] as ToggleItem[]);

  return (
    <div className="product-single-info">
      <Toggle style="flat" items={items} />
    </div>
  );
};

export default ProductInfo;
